module.exports = __webpack_public_path__ + "img/solution3.89940ed1.png";